import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'executing',
  templateUrl: './executing.component.html',
  styleUrls: ['./executing.component.scss']
})
export class ExecutingComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
